import { Editor, Value, Block, Text, Inline, Mark } from 'slate';

import { OBJECT_TYPES } from './constants';

export const isStartPointInBlock = ({ selection, blocks }: Value): boolean => {
	const block = blocks.first();
	const isEmptyBlock = block && !block.text;
	const isStartPoint = selection.start.offset === 0;
	return !isEmptyBlock && isStartPoint;
};

export const isStartPointInEmptyBlock = ({ selection, blocks }: Value): boolean => {
	const block = blocks.first();
	const isEmptyBlock = block && !block.text;
	const isStartPoint = selection.isCollapsed && selection.start.offset === 0;
	return isEmptyBlock && isStartPoint;
};

// tslint:disable-next-line: max-line-length
// By default Slate creates a new span without any marks in case of typing or pasting text in the start point of paragraph. This method gets marks from the first character of existing text and sets it to added text. This method is needed only if block contents inline nodes (links)
export const formatInsertionToStartPointOfBlock = (editor: Editor): void => {
	const { blocks, marks } = editor.value;
	const block = blocks.first();
	const inlineNode = block.nodes.find((node: Block | Text | Inline) => node.object === OBJECT_TYPES.inline) as Inline;

	if (!inlineNode) {
		return;
	}

	const blockMarks = block.getMarks();
	editor.insertText(''); // insertion of empty character helps to apply marks to the first inserted character in case some text in paragraph was previously selected
	marks.map((mark: Mark) => editor.removeMark(mark));
	blockMarks.forEach((mark: Mark) => editor.addMark(mark));
};

// By default Slate doesn't set any marks when external text is passed to empty block. This method gets last applied marks and applies it to pasted text
export const formatInsertionToEmptyBlock = (editor: Editor): void => {
	const { marks } = editor.value;
	const marksToReplace = marks;
	marks.map((mark: Mark) => editor.removeMark(mark));
	marksToReplace.forEach((mark: Mark) => editor.addMark(mark));
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Editor/RichTextEditor/helpers/formatUtils.ts